// extracted by mini-css-extract-plugin
export var downArrow = "_7s-0";
export var infoTooltipIcon = "_7s-3";
export var label = "_7s-1";
export var optionCard = "_7s-4";
export var upArrow = "_7s-2";